export enum AuthEvent {
  LOGOUT = "LOGOUT",
}

type AuthListener = (event: AuthEvent) => void;

class AuthEventBus {
  private listeners: AuthListener[] = [];

  subscribe(listener: AuthListener): () => void {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  emit(event: AuthEvent): void {
    this.listeners.forEach((listener) => listener(event));
  }
}

export const authEventBus = new AuthEventBus();
